import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import carIocn from "../../assets/images/car.png";
import img1 from "../../assets/images/1.png";
import { MyApi } from "../../MyApi";
import axios from "axios";
import { Link } from "react-router-dom";
export default function OurServices() {
 const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + MyApi.Our_servicess,
          { headers: { Authorization: MyApi.SECRET_KEY } }
        );

        if (res.data?.status) {
          setServices(res.data.data || []);
        }
      } catch (error) {
        console.error("Expert services API error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) {
    return <p className="text-center py-5">Loading services...</p>;
  }

  return (
    <div className="ourServices">
      <Container>
         <div className="section-title mb-4">
          <img src={carIocn} alt="" />
          <h2>Our Services</h2>
          <span>Complete cab solutions for every journey across Varanasi. Book Your Ride Instantly With Taxi Service Varanasi. </span>
        </div>

        <Row> 
        {services.length > 0 ? (
              services.map((item, index) => {
                // ✅ VERY IMPORTANT NULL CHECK
                if (!item?.product || !item?.parent_category) {
                  return null; // skip broken record
                }

                const product = item.product;
                const category = item.parent_category;

                return (
            <Col md="4" className="mb-4">
              <div className="whywinn h-100">
                 <Link to={`/${category.categoryurl}/${product.producturl}`}>
                     <img src={product.image_url || img1}  alt={product.productname}  className="white-icon" onError={(e) => (e.target.src = img1)} />
                  </Link>
                   <Link  to={`/${category.categoryurl}/${product.producturl}`}  style={{ textTransform: "capitalize" }}>
                <h4 className="mt-3">{product.productname}</h4>
                <p style={{ whiteSpace: "pre-line" }}>{product.productshortcontent}</p> 
                </Link>
              </div>
            </Col> 
  );
              })
            ) : (
              <Col>
                <p className="text-center">No services found</p>
              </Col>
            )}



        </Row>
      </Container>
    </div>
  );
}
